const Footer = () => {
  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-light footer-custom2">
      <div className="container-fluid ">

        <div className="navbar-header">

        </div>

        <div className="navbar-nav mr-auto">


        </div>

        <div className="nav navbar-right">
          <a className="navbar-brand" href="https://www.facebook.com/mcia4all"><img src="/images/base/facebook.jpg" alt="" width="40" height="40" className="rounded" /></a>
          <a className="navbar-brand" href="https://www.instagram.com/mcia4all/"><img src="/images/base/insta.jpg" alt="" width="40" height="40" className="rounded" /></a>
        </div>
      </div>
    </nav>

  );
}
export default Footer;
